import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FishersciPricingApiRequestInterface } from '@app/modules/tf-pricing/model/interfaces/fishersci-pricing-api-request.interface';
import { FishersciPricingApiResponseInterface } from '@app/modules/tf-pricing/model/interfaces/fishersci-pricing-api-response.interface';
import { FishersciPricingInterface } from '@app/modules/tf-pricing/model/interfaces/fishersci-pricing.interface';
import { map, Observable } from 'rxjs';

@Injectable()
export class FishersciPricingApiService {

    private pricingApi: string = '/taqman/api/v1/price';

    constructor(
        private http: HttpClient
    ) {
    }

    getPrice(sku: string): Observable<FishersciPricingInterface> {

        const payload: FishersciPricingApiRequestInterface = {
            parts: [
                {
                    partNumber: sku,
                    uom: '',
                    manufacturerPart: 'true'
                }
            ],
            callerId: ['magellan']
        };

        return this.http.post<FishersciPricingApiResponseInterface>(this.pricingApi, payload).pipe(
            map((response: FishersciPricingApiResponseInterface) => {
                return response.payload.parts[0];
            }
        ));

    }

}
